import { ADD_PERIODICITE, LISTE_PERIODICITE } from '@/i18n/fr/presse/periodicite/periodicite';
import { ADD_TYPE_PRODUIT, LISTE_TYPE_PRODUIT } from './typeProduit/typeProduit';
import { ADD_EMPLACEMENT_PRESSE, LISTE_EMPLACEMENT_PRESSE } from './emplacementPresse/emplacementPresse';
import { ADD_SURFACE, LISTE_SURFACE } from './surface/surface';
import { ADD_COULEUR_ENCART, LISTE_COULEUR_ENCART } from './couleurEncart/couleurEncart';
import { ADD_REGLE_FACTURATION, LISTE_REGLE_FACTURATION } from './regleFacturation/regleFacturation';
import { ADD_MODE_DISTRIBUTION, LISTE_MODE_DISTRIBUTION } from './modeDistribution/modeDistribution';
import { ADD_TYPE_FORMAT_PRESSE, LISTE_TYPE_FORMAT_PRESSE } from './typeFormatPresse/typeFormatPresse';
import { ADD_TYPE_EVENEMENT_SPONSORING, LISTE_TYPE_EVENEMENT_SPONSORING } from './typeEvenementSponsoring/typeEvenementSponsoring';
import {
  ADD_PARUTION, LISTE_PARUTION,
  DETAIL_PARUTION, BAT, CHEMIN_FER,
} from './parution/parution';
import { ADD_MARCHE, LISTE_MARCHE, DETAIL_MARCHE } from './marche/marche';
import { ADD_MOIS_COMPTABLE, LISTE_MOIS_COMPTABLE, DETAIL_MOIS_COMPTABLE } from './moisComptable/moisComptable';
import RELEVE_PRODUIT from './releveProduit/releveProduit';

const PRESSE = {
  listeTypeProduit: LISTE_TYPE_PRODUIT,
  addEditTypeProduit: ADD_TYPE_PRODUIT,
  listeCouleurEncart: LISTE_COULEUR_ENCART,
  addEditCouleurEncart: ADD_COULEUR_ENCART,
  listeRegleFacturation: LISTE_REGLE_FACTURATION,
  addEditRegleFacturation: ADD_REGLE_FACTURATION,
  listePeriodicite: LISTE_PERIODICITE,
  addEditPeriodicite: ADD_PERIODICITE,
  listeEmplacementPresse: LISTE_EMPLACEMENT_PRESSE,
  addEditEmplacementPresse: ADD_EMPLACEMENT_PRESSE,
  listeModeDistribution: LISTE_MODE_DISTRIBUTION,
  addEditModeDistribution: ADD_MODE_DISTRIBUTION,
  listeSurface: LISTE_SURFACE,
  addEditSurface: ADD_SURFACE,
  listeTypeFormatPresse: LISTE_TYPE_FORMAT_PRESSE,
  addEditTypeFormatPresse: ADD_TYPE_FORMAT_PRESSE,
  listeTypeEvenementSponsoring: LISTE_TYPE_EVENEMENT_SPONSORING,
  addEditTypeEvenementSponsoring: ADD_TYPE_EVENEMENT_SPONSORING,
  listeParution: LISTE_PARUTION,
  addEditParution: ADD_PARUTION,
  editBat: BAT,
  editCheminFer: CHEMIN_FER,
  detailParution: DETAIL_PARUTION,
  addEditMarche: ADD_MARCHE,
  listeMarche: LISTE_MARCHE,
  detailMarche: DETAIL_MARCHE,
  addEditMoisComptable: ADD_MOIS_COMPTABLE,
  listeMoisComptable: LISTE_MOIS_COMPTABLE,
  detailMoisComptable: DETAIL_MOIS_COMPTABLE,
  releveProduit: RELEVE_PRODUIT,
};

export default PRESSE;
